export default {
    getAppConfig(state) {
        return state.appConfig;
    },
    getCurrentBackground(state) {
        return state.currentBackground;
    },
    getCurrentAppSegment(state) {
        return state.appSegment;
    }
}
